import { OVERVIEW_SCOPE_IDS, OVERVIEW_SCOPE_LABELS } from "./resourceOverviewScopes";

const AGENT_GREETINGS = {
  "Board Agent": {
    overview: "Hi! I can help you plan and organize your boards.",
    scoped: (label) => `Hi! I'm here to help with ${label}.`,
    default: "Hi! Tap me if you need board help.",
  },
  "Table Agent": {
    overview: "Hi! I can help with tables, views, and your data.",
    scoped: (label) => `Hi! Need help with ${label}?`,
    default: "Hi! I'm your table assistant.",
  },
  "Workflow Operator": {
    overview: "Hi! I can help you build and edit workflows.",
    scoped: (label) => `Hi! Ready to work on ${label} with me?`,
    default: "Hi! I can help you shape this workflow.",
  },
  "Team Agent": {
    overview: "Hi! I can help you set up and run your teams.",
    scoped: (label) => `Hi! I'm here for ${label}.`,
    default: "Hi! Ask me anything about this team.",
  },
  "Docs Agent": {
    overview: "Hi! I can help you write and organize docs.",
    scoped: (label) => `Hi! I can help with ${label}.`,
    default: "Hi! Tap me when you want doc help.",
  },
  "Artifact Agent": {
    overview: "Hi! I can help you build and refine artifacts.",
    scoped: (label) => `Hi! Need a hand with ${label}?`,
    default: "Hi! I'm here to help with this artifact.",
  },
  "Agents Agent": {
    overview: "Hi! I can help you create and configure agents.",
    scoped: (label) => `Hi! I can help with ${label}.`,
    default: "Hi! Ask me about your agents.",
  },
  "Files Agent": {
    overview: "Hi! I can help you find, upload, and read files.",
    scoped: (label) => `Hi! I can help with ${label}.`,
    default: "Hi! Ask me about your files.",
  },
  "Custom Functions Agent": {
    overview: "Hi! I can help you write, test, and publish custom functions.",
    scoped: (label) => `Hi! I can help with ${label}.`,
    default: "Hi! Ask me about custom functions.",
  },
  "Forms Agent": {
    overview:
      "Hi! I can help you create, publish, and send forms and review tasks.",
    scoped: (label) => `Hi! I can help with ${label}.`,
    default: "Hi! Ask me about forms and review tasks.",
  },
};

function isOverviewScope(scopeId, scopeLabel) {
  if (scopeId && OVERVIEW_SCOPE_IDS.has(scopeId)) {
    return true;
  }
  return Boolean(scopeLabel && OVERVIEW_SCOPE_LABELS.has(scopeLabel));
}

/**
 * Returns true when the greeting will not upgrade from a generic default to a scoped label.
 */
export function isContextAgentAttentionMessageReady({
  agentName,
  scopeLabel,
  scopeId,
  attentionMessage,
}) {
  if (attentionMessage?.trim()) {
    return true;
  }
  if (isOverviewScope(scopeId, scopeLabel)) {
    return true;
  }
  if (scopeId && !OVERVIEW_SCOPE_IDS.has(scopeId)) {
    return Boolean(scopeLabel?.trim() && scopeLabel !== agentName);
  }
  return true;
}

/**
 * First-person greeting shown above context-agent launchers when scope registers.
 */
export default function buildContextAgentAttentionMessage({
  agentName,
  scopeLabel,
  scopeId,
  attentionMessage,
}) {
  if (attentionMessage?.trim()) {
    return attentionMessage.trim();
  }

  const greetings = AGENT_GREETINGS[agentName];
  if (!greetings) {
    if (scopeLabel && scopeLabel !== agentName) {
      return `Hi! I'm here to help with ${scopeLabel}.`;
    }
    return `Hi! I'm ${agentName}.`;
  }

  if (isOverviewScope(scopeId, scopeLabel)) {
    return greetings.overview;
  }

  if (scopeLabel && scopeLabel !== agentName) {
    return greetings.scoped(scopeLabel);
  }

  return greetings.default;
}
